import React, { useState, useEffect } from "react";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { useTranslation } from "react-i18next";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { apiProcessPayment } from "../../../utils/API/TrxNowAPI";

//import DialogContainerTest from 'webapp/components/Dialog'

import "./PaymentRequired.scss";
import { Fragment } from "react";
import { devLog } from "utils/devLog";

export default function CheckoutForm(props) {
  const { t } = useTranslation();
  const validEmail = new RegExp("^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]$");
  const [succeeded, setSucceeded] = useState(false);
  const [error, setError] = useState(null);
  const [processing, setProcessing] = useState("");
  const [showCancel, setShowCancel] = useState(true);
  const [disabled, setDisabled] = useState(true);
  const [clientSecret, setClientSecret] = useState("");
  const [email, setEmail] = useState("");
  const stripe = useStripe();
  const elements = useElements();

  useEffect(() => {
    // create a payment intent as soon as the page loads
    window
      .fetch("/create-payment-intent", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          totalAmount: props.quoteAmount,
          currency: props.quoteCurrency,
        }),
      })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        devLog(data);
        setClientSecret(data.clientSecret);
      });
  }, []);

  const cardStyle = {
    style: {
      base: {
        color: "#32325d",
        fontFamily: "Arial, sans-serif",
        fontSmoothing: "antialiased",
        fontSize: "16px",
        "::placeholder": {
          color: "#32325d",
        },
      },
      invalid: {
        color: "#fa755a",
        iconColor: "#fa755a",
      },
    },
  };

  const emailCheck = (email) => {
    return validEmail.test(email);
  };

  const handleChange = async (event) => {
    // Listen for changes in the CardElement
    // and display any errors as the customer types their card details
    setDisabled(event.empty);
    setError(event.error ? event.error.message : "");
  };
  //4242424242424242 any date any ccv
  const handleSubmit = async (ev) => {
    ev.preventDefault();
    setProcessing(true);

    //check email validation first
    //return out if email fails
    if (!emailCheck(email) || email.slice(email.length) === " ") {
      //
      setProcessing(false);
      setError(t("description.InvalidEmailPaymentSpace"));
    } else if (!emailCheck(email)) {
      setProcessing(false);
      setError(t("description.InvalidEmailPayment"));
    } else {
      const payload = await stripe.confirmCardPayment(clientSecret, {
        receipt_email: email,
        payment_method: {
          card: elements.getElement(CardElement),
        },
      });

      //if payment failed
      if (payload.error) {
        setError(`${payload.error.message}`);
        setProcessing(false);
        setShowCancel(true);
      }

      //if payment succeeded
      else {
        setError(null);
        setProcessing(false);
        setSucceeded(true);
        setShowCancel(false);
        devLog(payload);

        if (payload.paymentIntent.status === "succeeded") {
          devLog("Payment Succeeded!");

          // call API to let server know
          apiProcessPayment(
            props.encCallGUID,
            payload.paymentIntent.receipt_email,
            props.companyParams,
            payload.paymentIntent.id,
            (responseParams) => {
              devLog("apiProcessPayment callback result:", responseParams);
            },
          );
        }
      }
    }
  };

  return (
    <Fragment>
      {/* {props.encCallGUID || "no encCallGUID Yet"} */}

      {/* Show any error that happens when processing the payment */}
      {error && (
        <Fragment>
          <div className="card-error" role="alert">
            {error}
          </div>
        </Fragment>
      )}

      <div className="stripe-root stripe-body">
        <form id="payment-form" className="stripe-form" hidden={succeeded} onSubmit={handleSubmit}>
          <input
            type="text"
            className="stripe-input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder={t("description.PaymentRequiredPlaceholder1")}
          />
          <CardElement id="card-element" options={cardStyle} onChange={handleChange} />
          <button className="stripe-button" disabled={processing || disabled || succeeded} id="submit">
            <span id="button-text">
              {processing ? (
                <div className="stripe-spinner" id="spinner"></div>
              ) : (
                t("description.PaymentRequiredButton1")
              )}
            </span>
          </button>
          {/* Show a success message upon completion */}
          {showCancel && (
            <button
              className="paymentBase ui-btn"
              onClick={(e) => {
                e.preventDefault();
                // todo: cancel the call -- do "cancelcall"
                if (typeof props.onUserCancel === "function") {
                  props.onUserCancel();
                } else {
                  console.warn("PaymentRequired", "No cancel callback available");
                }
              }}
            >
              {t("description.PaymentRequiredButton2")}
            </button>
          )}
        </form>

        <div className={succeeded ? "stripe-result-message" : "stripe-result-message stripe-hidden"}>
          <strong>{t("description.PaymentRequiredAcceptedPayment")}</strong>
          <br />
          <div style={{ color: "green", margin: 5 }}>
            {" "}
            <CheckCircleIcon style={{ fontSize: "100px" }} />{" "}
          </div>
          <strong>One Moment Please...</strong>
          <br />
          <div style={{ fontSize: 14, marginBottom: 20 }}>
            <strong>The app will auto-resume automatically</strong>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
